import type { oz } from '@weft/utils';
import { created } from '../../utils';
import { NewUsageVariantChargeSchema } from './new-usage-variant-charge-schema';

export const UsageVariantChargeSchema = created(NewUsageVariantChargeSchema);

export type UsageVariantCharge = oz.infer<typeof UsageVariantChargeSchema>;